var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLabel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "343px",
    height: "390px",
    viewBox: "0 0 343 390",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "whiteLabel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7CE3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8338EC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BAEF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C87A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.5%",
    y1: "12.7%",
    x2: "53.5%",
    y2: "81.4%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9EF",
    offset: "48.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BAEF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C87A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500806452,0.00043003907 L21.861871,0.00043003907 C22.1263722,-0.0104370681 22.3502545,0.18597519 22.3626774,0.439788281 L22.3626774,23.3027949 C22.3502545,23.556608 22.1263722,23.7530202 21.861871,23.7421531 L0.500806452,23.7421531 C0.236305243,23.7530202 0.0124229608,23.556608 0,23.3027949 L0,0.439788281 C0.0124229608,0.18597519 0.236305243,-0.0104370681 0.500806452,0.00043003907 L0.500806452,0.00043003907 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-44.7%",
    y: "-33.7%",
    width: "189.4%",
    height: "184.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52%",
    y1: "8.61607052%",
    x2: "50%",
    y2: "91.3839295%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0",
    offset: "37.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3",
    offset: "76.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500806452,0.00043003907 L21.861871,0.00043003907 C22.1263722,-0.0104370681 22.3502545,0.18597519 22.3626774,0.439788281 L22.3626774,23.3027949 C22.3502545,23.556608 22.1263722,23.7530202 21.861871,23.7421531 L0.500806452,23.7421531 C0.236305243,23.7530202 0.0124229608,23.556608 0,23.3027949 L0,0.439788281 C0.0124229608,0.18597519 0.236305243,-0.0104370681 0.500806452,0.00043003907 L0.500806452,0.00043003907 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-44.7%",
    y: "-33.7%",
    width: "189.4%",
    height: "184.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500806452,0.00043003907 L21.861871,0.00043003907 C22.1263722,-0.0104370681 22.3502545,0.18597519 22.3626774,0.439788281 L22.3626774,23.3027949 C22.3502545,23.556608 22.1263722,23.7530202 21.861871,23.7421531 L0.500806452,23.7421531 C0.236305243,23.7530202 0.0124229608,23.556608 0,23.3027949 L0,0.439788281 C0.0124229608,0.18597519 0.236305243,-0.0104370681 0.500806452,0.00043003907 L0.500806452,0.00043003907 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-44.7%",
    y: "-33.7%",
    width: "189.4%",
    height: "184.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500806452,0.00043003907 L21.861871,0.00043003907 C22.1263722,-0.0104370681 22.3502545,0.18597519 22.3626774,0.439788281 L22.3626774,23.3027949 C22.3502545,23.556608 22.1263722,23.7530202 21.861871,23.7421531 L0.500806452,23.7421531 C0.236305243,23.7530202 0.0124229608,23.556608 0,23.3027949 L0,0.439788281 C0.0124229608,0.18597519 0.236305243,-0.0104370681 0.500806452,0.00043003907 L0.500806452,0.00043003907 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-44.7%",
    y: "-33.7%",
    width: "189.4%",
    height: "184.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500806452,0.00043003907 L21.861871,0.00043003907 C22.1263722,-0.0104370681 22.3502545,0.18597519 22.3626774,0.439788281 L22.3626774,23.3027949 C22.3502545,23.556608 22.1263722,23.7530202 21.861871,23.7421531 L0.500806452,23.7421531 C0.236305243,23.7530202 0.0124229608,23.556608 0,23.3027949 L0,0.439788281 C0.0124229608,0.18597519 0.236305243,-0.0104370681 0.500806452,0.00043003907 L0.500806452,0.00043003907 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-44.7%",
    y: "-33.7%",
    width: "189.4%",
    height: "184.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500806452,0.00043003907 L21.861871,0.00043003907 C22.1263722,-0.0104370681 22.3502545,0.18597519 22.3626774,0.439788281 L22.3626774,23.3027949 C22.3502545,23.556608 22.1263722,23.7530202 21.861871,23.7421531 L0.500806452,23.7421531 C0.236305243,23.7530202 0.0124229608,23.556608 0,23.3027949 L0,0.439788281 C0.0124229608,0.18597519 0.236305243,-0.0104370681 0.500806452,0.00043003907 L0.500806452,0.00043003907 Z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-44.7%",
    y: "-33.7%",
    width: "189.4%",
    height: "184.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB3780",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8800",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9EF",
    offset: "46.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B97E2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B1AE2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9EF",
    offset: "46.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-65.000000, -37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "whiteLabel",
    transform: "translate(65.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.534814,8.57112066 C178.729386,-16.9947773 187.249347,18.0260185 173.640439,68.7835703 L172.761522,72.0271389 C163.15981,107.129326 149.742479,146.696493 166.81987,173.061837 C182.867986,195.95172 208.367959,178.939702 258.02556,174.479458 C293.138356,170.126701 316.690262,152.474867 330.919363,173.086901 C359.13497,225.828669 330.46946,287.994947 280.156416,333.462376 C212.016011,395.038956 80.5258394,410.952492 19.7107499,353.095189 C-19.3804686,305.890652 10.1024218,184.393621 19.7419026,151.924964 C29.3813833,119.456307 62.3402421,34.1370186 120.534814,8.57112066 Z",
    id: "Path_1022",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-imac",
    transform: "translate(27.350711, 117.523958)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.024149,197.299121 L76.5671827,197.299121 C94.2365325,197.299121 94.2365325,164.913932 94.2365325,164.913932 L141.354799,164.913932 C141.354799,164.913932 141.354799,197.299121 159.024149,197.299121 Z",
    id: "Path_923",
    fill: "#C3D1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.811765,0 L11.7795666,0 C5.28175088,0.0189349889 0.0189349889,5.28175088 1.91384576e-15,11.7795666 L1.91384576e-15,141.354799 L235.591331,141.354799 L235.591331,11.7795666 C235.572396,5.28175088 230.30958,0.0189349889 223.811765,0 Z",
    id: "Path_924",
    fill: "url(#linearGradient-2)",
    opacity: 0.679
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_925",
    fill: "url(#linearGradient-3)",
    points: "5.25411765 6.77253251 230.337214 6.77253251 230.337214 135.314898 5.25411765 135.314898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,141.354799 L235.591331,141.354799 L235.591331,153.134365 C235.572396,159.632181 230.30958,164.894997 223.811765,164.913932 L11.7795666,164.913932 C5.28175088,164.894997 0.0189349889,159.632181 0,153.134365 L0,141.354799 Z M164.913932,197.039827 L70.6773994,197.039827 L70.6773994,202.394502 L164.913932,202.394502 L164.913932,197.039827 Z",
    id: "Path_926",
    fill: "#E8EBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.795666,147.244582 C114.542828,147.244582 111.905882,149.881528 111.905882,153.134365 C111.905882,156.387203 114.542828,159.024149 117.795666,159.024149 C121.048503,159.024149 123.685449,156.387203 123.685449,153.134365 C123.685449,149.881528 121.048503,147.244582 117.795666,147.244582 Z",
    id: "Path_927",
    fill: "url(#linearGradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "browser",
    transform: "translate(67.791974, 141.063698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.603344, 1.221053)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.450561,97.3897214 C148.453348,98.1104965 147.873393,98.6981545 147.152644,98.7048669 L1.79351084,98.7048669 C1.07276156,98.6981545 0.492806306,98.1104965 0.495593638,97.3897214 L0.495593638,1.37978947 C0.492806306,0.659014373 1.07276156,0.0713563353 1.79351084,0.0646439628 L147.152644,0.0646439628 C147.873393,0.0713563353 148.453348,0.659014373 148.450561,1.37978947 L148.450561,97.3897214 Z",
    id: "Path_972-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.32933746,0.580359133 L147.737313,0.580359133 C148.530688,0.580359133 149.173845,1.22351664 149.173845,2.01689164 L149.173845,9.67073684 L0.892804954,9.67073684 L0.892804954,2.01689164 C0.892804954,1.22351664 1.53596246,0.580359133 2.32933746,0.580359133 Z",
    id: "Rectangle_112",
    fill: "#00BAEF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: "YOUR-LOGO-HERE",
    fill: "#FFFFFF",
    fontFamily: "Europa-Bold",
    fontSize: 3.5,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.55093498,
    y: 6.28606811
  }, "YOUR LOGO HERE")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5,
    x: 38.2080258,
    y: 3.39641674,
    width: 10,
    height: 3.65714286,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5,
    x: 50.9195643,
    y: 3.39641674,
    width: 10,
    height: 3.65714286,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5,
    x: 64.688795,
    y: 3.39641674,
    width: 10,
    height: 3.65714286,
    rx: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_94",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5,
    cx: 142.16218,
    cy: 5.07230245,
    rx: 3.36403846,
    ry: 3.136
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_95",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5,
    cx: 133.511795,
    cy: 5.07321674,
    rx: 1.44173077,
    ry: 1.344
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_96",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5,
    cx: 126.782737,
    cy: 5.07321674,
    rx: 1.44173077,
    ry: 1.344
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5,
    cx: 120.05368,
    cy: 5.07321674,
    rx: 1.44173077,
    ry: 1.344
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_98",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5,
    cx: 113.325603,
    cy: 5.07321674,
    rx: 1.44173077,
    ry: 1.344
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(20.208026, 19.936302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    fill: "#EFEFEF",
    fillRule: "nonzero",
    opacity: 0.749,
    x: 82,
    y: 14,
    width: 28,
    height: 54,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "track-6",
    opacity: 0.5,
    transform: "translate(0.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_461-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500862944,0 L21.8643371,0 C22.1373994,-0.00296861904 22.3615352,0.195807483 22.3652,0.444226741 L22.3652,12 L0,12 L0,0.444226741 C0.00366482926,0.195807483 0.227800608,-0.00296861904 0.500862944,0 L0.500862944,0 Z",
    id: "Path_464-6",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50657858,17.5384615 L18.5734214,17.5384615 C18.9858876,17.5384615 19.32,18.0490129 19.32,18.6780123 L19.32,20.0912185 C19.32,20.7208986 18.9858876,21.2307692 18.5734214,21.2307692 L3.50657858,21.2307692 C3.0941124,21.2307692 2.76,20.7202178 2.76,20.0912185 L2.76,18.6780123 C2.76,18.0483322 3.09115565,17.5384615 3.50657858,17.5384615 Z",
    id: "Path_470-6",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91044288,13.8461538 L19.1695571,13.8461538 C19.2530529,13.8461538 19.32,13.9354839 19.32,14.0456576 L19.32,14.569727 C19.32,14.6799007 19.2523007,14.7692308 19.1695571,14.7692308 L2.91044288,14.7692308 C2.82694708,14.7692308 2.76,14.6799007 2.76,14.569727 L2.76,14.0456576 C2.76,13.9354839 2.8276993,13.8461538 2.91044288,13.8461538 Z",
    id: "Path_473-6",
    fill: "#D0D1D3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "track-6-copy",
    opacity: 0.5,
    transform: "translate(0.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_461-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500862944,0 L21.8643371,0 C22.1373994,-0.00296861904 22.3615352,0.195807483 22.3652,0.444226741 L22.3652,12 L0,12 L0,0.444226741 C0.00366482926,0.195807483 0.227800608,-0.00296861904 0.500862944,0 L0.500862944,0 Z",
    id: "Path_464-6",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50657858,17.5384615 L18.5734214,17.5384615 C18.9858876,17.5384615 19.32,18.0490129 19.32,18.6780123 L19.32,20.0912185 C19.32,20.7208986 18.9858876,21.2307692 18.5734214,21.2307692 L3.50657858,21.2307692 C3.0941124,21.2307692 2.76,20.7202178 2.76,20.0912185 L2.76,18.6780123 C2.76,18.0483322 3.09115565,17.5384615 3.50657858,17.5384615 Z",
    id: "Path_470-6",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91044288,13.8461538 L19.1695571,13.8461538 C19.2530529,13.8461538 19.32,13.9354839 19.32,14.0456576 L19.32,14.569727 C19.32,14.6799007 19.2523007,14.7692308 19.1695571,14.7692308 L2.91044288,14.7692308 C2.82694708,14.7692308 2.76,14.6799007 2.76,14.569727 L2.76,14.0456576 C2.76,13.9354839 2.8276993,13.8461538 2.91044288,13.8461538 Z",
    id: "Path_473-6",
    fill: "#D0D1D3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "track-6",
    opacity: 0.5,
    transform: "translate(27.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_461-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500862944,0 L21.8643371,0 C22.1373994,-0.00296861904 22.3615352,0.195807483 22.3652,0.444226741 L22.3652,12 L0,12 L0,0.444226741 C0.00366482926,0.195807483 0.227800608,-0.00296861904 0.500862944,0 L0.500862944,0 Z",
    id: "Path_464-6",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50657858,17.5384615 L18.5734214,17.5384615 C18.9858876,17.5384615 19.32,18.0490129 19.32,18.6780123 L19.32,20.0912185 C19.32,20.7208986 18.9858876,21.2307692 18.5734214,21.2307692 L3.50657858,21.2307692 C3.0941124,21.2307692 2.76,20.7202178 2.76,20.0912185 L2.76,18.6780123 C2.76,18.0483322 3.09115565,17.5384615 3.50657858,17.5384615 Z",
    id: "Path_470-6",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91044288,13.8461538 L19.1695571,13.8461538 C19.2530529,13.8461538 19.32,13.9354839 19.32,14.0456576 L19.32,14.569727 C19.32,14.6799007 19.2523007,14.7692308 19.1695571,14.7692308 L2.91044288,14.7692308 C2.82694708,14.7692308 2.76,14.6799007 2.76,14.569727 L2.76,14.0456576 C2.76,13.9354839 2.8276993,13.8461538 2.91044288,13.8461538 Z",
    id: "Path_473-6",
    fill: "#D0D1D3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "track-6",
    opacity: 0.5,
    transform: "translate(27.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_461-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500862944,0 L21.8643371,0 C22.1373994,-0.00296861904 22.3615352,0.195807483 22.3652,0.444226741 L22.3652,12 L0,12 L0,0.444226741 C0.00366482926,0.195807483 0.227800608,-0.00296861904 0.500862944,0 L0.500862944,0 Z",
    id: "Path_464-6",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50657858,17.5384615 L18.5734214,17.5384615 C18.9858876,17.5384615 19.32,18.0490129 19.32,18.6780123 L19.32,20.0912185 C19.32,20.7208986 18.9858876,21.2307692 18.5734214,21.2307692 L3.50657858,21.2307692 C3.0941124,21.2307692 2.76,20.7202178 2.76,20.0912185 L2.76,18.6780123 C2.76,18.0483322 3.09115565,17.5384615 3.50657858,17.5384615 Z",
    id: "Path_470-6",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91044288,13.8461538 L19.1695571,13.8461538 C19.2530529,13.8461538 19.32,13.9354839 19.32,14.0456576 L19.32,14.569727 C19.32,14.6799007 19.2523007,14.7692308 19.1695571,14.7692308 L2.91044288,14.7692308 C2.82694708,14.7692308 2.76,14.6799007 2.76,14.569727 L2.76,14.0456576 C2.76,13.9354839 2.8276993,13.8461538 2.91044288,13.8461538 Z",
    id: "Path_473-6",
    fill: "#D0D1D3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "track-6",
    opacity: 0.5,
    transform: "translate(53.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_461-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500862944,0 L21.8643371,0 C22.1373994,-0.00296861904 22.3615352,0.195807483 22.3652,0.444226741 L22.3652,12 L0,12 L0,0.444226741 C0.00366482926,0.195807483 0.227800608,-0.00296861904 0.500862944,0 L0.500862944,0 Z",
    id: "Path_464-6",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50657858,17.5384615 L18.5734214,17.5384615 C18.9858876,17.5384615 19.32,18.0490129 19.32,18.6780123 L19.32,20.0912185 C19.32,20.7208986 18.9858876,21.2307692 18.5734214,21.2307692 L3.50657858,21.2307692 C3.0941124,21.2307692 2.76,20.7202178 2.76,20.0912185 L2.76,18.6780123 C2.76,18.0483322 3.09115565,17.5384615 3.50657858,17.5384615 Z",
    id: "Path_470-6",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91044288,13.8461538 L19.1695571,13.8461538 C19.2530529,13.8461538 19.32,13.9354839 19.32,14.0456576 L19.32,14.569727 C19.32,14.6799007 19.2523007,14.7692308 19.1695571,14.7692308 L2.91044288,14.7692308 C2.82694708,14.7692308 2.76,14.6799007 2.76,14.569727 L2.76,14.0456576 C2.76,13.9354839 2.8276993,13.8461538 2.91044288,13.8461538 Z",
    id: "Path_473-6",
    fill: "#D0D1D3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "track-6",
    opacity: 0.5,
    transform: "translate(53.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_461-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.500862944,0 L21.8643371,0 C22.1373994,-0.00296861904 22.3615352,0.195807483 22.3652,0.444226741 L22.3652,12 L0,12 L0,0.444226741 C0.00366482926,0.195807483 0.227800608,-0.00296861904 0.500862944,0 L0.500862944,0 Z",
    id: "Path_464-6",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50657858,17.5384615 L18.5734214,17.5384615 C18.9858876,17.5384615 19.32,18.0490129 19.32,18.6780123 L19.32,20.0912185 C19.32,20.7208986 18.9858876,21.2307692 18.5734214,21.2307692 L3.50657858,21.2307692 C3.0941124,21.2307692 2.76,20.7202178 2.76,20.0912185 L2.76,18.6780123 C2.76,18.0483322 3.09115565,17.5384615 3.50657858,17.5384615 Z",
    id: "Path_470-6",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91044288,13.8461538 L19.1695571,13.8461538 C19.2530529,13.8461538 19.32,13.9354839 19.32,14.0456576 L19.32,14.569727 C19.32,14.6799007 19.2523007,14.7692308 19.1695571,14.7692308 L2.91044288,14.7692308 C2.82694708,14.7692308 2.76,14.6799007 2.76,14.569727 L2.76,14.0456576 C2.76,13.9354839 2.8276993,13.8461538 2.91044288,13.8461538 Z",
    id: "Path_473-6",
    fill: "#D0D1D3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    fill: "#EAEAEA",
    fillRule: "nonzero",
    opacity: 0.749,
    x: 0,
    y: 0,
    width: 110,
    height: 10,
    rx: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons8-ipad",
    transform: "translate(204.589891, 222.551530)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.09000898e-15,116.235294 L-2.09000898e-15,12.2352941 C0.0202466924,5.48612077 5.62726819,0.0197388495 12.5500849,1.35839052e-15 L87.8505942,1.35839052e-15 C94.7734109,0.0197388495 100.380432,5.48612077 100.400679,12.2352941 L100.400679,116.235294 C100.380432,122.984467 94.7734109,128.450849 87.8505942,128.470588 L12.5500849,128.470588 C5.62726819,128.450849 0.0202466924,122.984467 -2.09000898e-15,116.235294 Z",
    id: "Path_1010",
    fill: "url(#linearGradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8505942,9.17647059 L12.5500849,9.17647059 C11.7033141,9.1265996 10.8752048,9.43281846 10.2753558,10.0176215 C9.67550688,10.6024246 9.3614096,11.4097627 9.41256367,12.2352941 L9.41256367,107.058824 C9.3614096,107.884355 9.67550688,108.691693 10.2753558,109.276496 C10.8752048,109.861299 11.7033141,110.167518 12.5500849,110.117647 L87.8505942,110.117647 C88.697365,110.167518 89.5254743,109.861299 90.1253233,109.276496 C90.7251722,108.691693 91.0392695,107.884355 90.9881154,107.058824 L90.9881154,12.2352941 C91.0392695,11.4097627 90.7251722,10.6024246 90.1253233,10.0176215 C89.5254743,9.43281846 88.697365,9.1265996 87.8505942,9.17647059 Z",
    id: "Path_1011",
    fill: "url(#linearGradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2003396,114.705882 C47.6011319,114.705882 45.4940577,116.760105 45.4940577,119.294118 C45.4940577,121.82813 47.6011319,123.882353 50.2003396,123.882353 C52.7995472,123.882353 54.9066214,121.82813 54.9066214,119.294118 C54.9066214,116.760105 52.7995472,114.705882 50.2003396,114.705882 Z",
    id: "Path_1012",
    fill: "#A6642A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-android",
    transform: "translate(283.341674, 282.963295)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.39333932e-15,63.3176471 L-1.39333932e-15,7.03529412 C0.0116311387,3.1545151 3.23567476,0.0113393976 7.21629881,-1.35839052e-15 L36.0814941,-1.35839052e-15 C40.0621181,0.0113393976 43.2861617,3.1545151 43.2977929,7.03529412 L43.2977929,63.3176471 C43.2861617,67.1984261 40.0621181,70.3416018 36.0814941,70.3529412 L7.21629881,70.3529412 C3.23567476,70.3416018 0.0116311387,67.1984261 -1.39333932e-15,63.3176471 Z",
    id: "Path_1013",
    fill: "url(#linearGradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0814941,5.27635253 L7.21629881,5.27635253 C6.70449908,5.27067643 6.21455457,5.47838958 5.86988482,5.84728601 C5.52521508,6.21618245 5.35867762,6.71109511 5.41222411,7.20735294 L5.41222411,63.1937647 C5.35867762,63.6900225 5.52521508,64.1849352 5.86988482,64.5538316 C6.21455457,64.9227281 6.70449908,65.1304412 7.21629881,65.1247651 L36.0814941,65.1247651 C36.5932938,65.1304412 37.0832383,64.9227281 37.427908,64.5538316 C37.7725778,64.1849352 37.9391152,63.6900225 37.8855688,63.1937647 L37.8855688,7.20735294 C37.9391152,6.71109511 37.7725778,6.21618245 37.427908,5.84728601 C37.0832383,5.47838958 36.5932938,5.27067643 36.0814941,5.27635253 Z",
    id: "Path_1023",
    fill: "url(#linearGradient-21)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLabel);
export default __webpack_public_path__ + "static/media/whiteLabel.4e37cb37aa1d788961f7a613b81a2700.svg";
export { ForwardRef as ReactComponent };